
import { types } from '../api';

export const listTypes = (callback) => {
    const res = types.list()

    res.then(() => {
        if (callback) callback();
    });

    return {
        type: 'GET_TYPES',
        payload: res,
    };
}